export class LiveReconciliationStatus {
  private statuses;
  constructor() {
    this.statuses = new Map();
    this.statuses.set(21, 'Complete');
    this.statuses.set(33, 'Reject');
  }

  public labelStatusByCode(statusCode: number): string {
    return this.statuses.get(statusCode);
  }
}
